import useSWR from 'swr';
import { getReportEventCacheKey } from '@/constants/cache-keys';
import { EngineService } from '@/services/engine';
import type { ReportEventDetail } from '@/types/report';

interface UseReportEventResult {
    reportEvent: ReportEventDetail | null;
    isLoading: boolean;
    error: Error | null;
}

export function useReportEvent(eventId: string): UseReportEventResult {
    const { data, error, isLoading } = useSWR<ReportEventDetail>(
        eventId ? getReportEventCacheKey(eventId) : null,
        () => EngineService.getReportEvent(eventId),
        { keepPreviousData: true },
    );

    return {
        reportEvent: data ?? null,
        isLoading,
        error: (error as Error | undefined) ?? null,
    };
}
